import { useToast } from '@/hooks/useToast';

export default function SubscribeCTA() {
  const { show, node } = useToast();

  return (
    <section id="subscribe" className="px-4 md:px-8 pt-16 md:pt-28">
      <div className="mx-auto max-w-6xl">
        <div className="relative overflow-hidden rounded-lg border border-primary-200 bg-primary-50 px-4 md:px-12 py-10 md:py-14">
          <div className="relative z-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-xl">
              <span className="text-xs tracking-[0.25em] text-primary-700">更新提醒</span>
              <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                时间线补齐时，你第一个知道
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                有新素材、新声明或证据链更新时，提醒会按专题推送。当前页面为静态展示，
                按钮只做视觉演示，不会真正提交任何信息。
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 lg:shrink-0">
              <button
                type="button"
                onClick={() => show('已开启更新提醒（演示，未接入真实推送）')}
                className="flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer hover:bg-primary-600"
              >
                <i className="ri-notification-3-line w-4 h-4 flex items-center justify-center" />
                开启更新提醒
              </button>
              <button
                type="button"
                onClick={() => {
                  navigator.clipboard
                    ?.writeText('爆料黑料 · 深扒专题合集')
                    .then(() => show('已复制专题合集名称'))
                    .catch(() => show('当前环境无法复制，请手动记录'));
                }}
                className="flex items-center justify-center gap-2 px-6 py-3.5 rounded-md border border-primary-300 bg-background-50 text-primary-700 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer hover:bg-primary-100"
              >
                <i className="ri-share-forward-line w-4 h-4 flex items-center justify-center" />
                分享合集
              </button>
            </div>
          </div>

          <div className="absolute -right-10 -bottom-16 hidden lg:flex w-56 h-56 items-center justify-center rounded-full bg-accent-100/70 text-accent-300">
            <i className="ri-drag-move-2-line w-32 h-32 flex items-center justify-center" />
          </div>
        </div>
      </div>
      {node}
    </section>
  );
}